/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Flotador } from "./modelFlotador";

class ControllerFlotador extends ControllerModel {
  constructor() {
    super("ControllerFlotador");
    
    this.setNewNode = (callback) => {
      let _flotador = new Flotador();
      _flotador.decorate(callback);

      this.addNode(_flotador);
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let _flotador = new Flotador();
      _flotador.copyFrom(node);
      _flotador.decorate(callback);
      this.addNode(_flotador)
    }

    this.getProperties = async (node) => {
      let n = new Flotador();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Flotador();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerFlotador };
